export default {
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    // dev: 'http://59.110.235.20:8091/apis/supplier'
    // test: 'http://192.168.1.195:8091/apis/supplier'
    dev: " http://dev01-sra.iccec.cn"
    // dev: " http://test01-sra.iccec.cn"
    // dev: " http://uat01-sra.iccec.cn"
  },
  /**
   * 多语言配置
   * */
  // CCUI统一标准语言标识
  // ar 阿拉伯语（暂定）
  // en-gb 英语
  // fr-fr 法语
  // es-es 西班牙语
  // ru-ru 俄语
  // zh-cn 中文
  i18n: {
    // 默认语言
    cookieLable: "language",
    default: 'zh-cn', // 中文 zh-CN  英语 en-US
    // 是否根据用户电脑配置自动设置语言（仅第一次有效）
    auto: false
  },
};
